module.exports = __webpack_public_path__ + "img/hemline_sweep.9869a4cc.png";